import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseTheme } from '../base-theme';

@Component({
  selector: 'app-minimal-invoice-theme',
  templateUrl: './minimal-invoice-theme.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MinimalInvoiceThemeComponent extends BaseTheme {
  protected loadContentAreas(): void {
    throw new Error('Method not implemented.');
  }
}
